import styled, { keyframes } from "styled-components";

export const ListContainer = styled.div`
  width: 442px;
  border-radius: 8px;
  background: ${props => props.theme.backgroundDark};
  border: ${props => props.theme.border.standard} solid
    ${props => props.theme.border.color};
  box-shadow: ${props => props.theme.boxShadowBottom};
  overflow: hidden;

  .read-all {
    cursor: pointer;
    &:hover p {
      color: ${props => props.theme.textLight};
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(0, 0, 0, 0.25);
    border-bottom: solid 1px ${props => props.theme.backgroundTag};
    padding: 5px 24px;
  }
  .scroll-area {
    max-height: 480px;
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 8px;
      opacity: 0;
    }
    ::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.06);
      opacity: 0.6;
      border-radius: 2px;
    }
  }
  .no-notifications {
    display: grid;
    justify-content: center;
    padding: 20px;
  }
`;

export const Badge = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${props => props.theme.highlight};
  /* border: solid 1px ${props => props.theme.backgroundDark}; */
  position: absolute;
  top: -4px;
  right: -3px;
`;

export const BlueShrinkAnimation = keyframes`
  0%   { left:0; } 
  100% { left:100%; }
`;

export const NewNotification = styled.div`
  position: fixed;
  top: 80px;
  right: 8px;
  width: 380px;
  border-radius: 15px;
  overflow: hidden;
  z-index: ${props => props.theme.zIndex.notification};
  border: ${props => props.theme.border.standard} solid
    ${props => props.theme.border.color};
  .blueShrink {
    background: #6e70b0;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 100%;
    animation-name: ${BlueShrinkAnimation};
    animation-duration: 6s;
  }
  .innerNotification {
    position: relative;
    background: ${props => props.theme.backgroundDark};
    margin-top: 10px;
    border-radius: 15px;

    .content {
      padding-top: 14px;
    }
  }
`;

export const CardContainer = styled.div`
  display: grid;

  width: 100%;
  grid-template-columns: auto 1fr 84px;
  grid-template-rows: 80px;
  padding: 0 20px 0 18px;
  align-items: center;
  overflow: hidden;

  /* Pin content to top of its cell while avatar and time stay centered */
  .content {
    align-self: start;
    padding-top: 22px;
    padding-right: 12px;
  }

  cursor: pointer;

  &:hover {
    background: ${props => props.theme.backgroundLight};
  }

  .grey {
    color: ${props => props.theme.textDark};
  }
  .link {
    color: ${props => props.theme.highlight};
  }

  .content {
    margin-left: 20px;
    min-width: 0;

    .body p {
      display: inline;
      color: ${props => props.theme.grey3};
      font-size: 12px;
      line-height: 1.25;
    }
    .body {
      color: ${props => props.theme.grey3};
      width: 100%;
      font-size: 12px;
      line-height: 1.25;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  .time {
    font-size: 11px;
  }
  .name {
    margin-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .time-container {
    display: flex;
    gap: 8px;
    align-items: center;
  }
  .time-sub-container {
    display: flex;
    align-items: center;
  }
  .unread {
    background: ${props => props.theme.highlight};
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
`;
